import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Heart, ArrowLeft } from 'lucide-react';
import PublicHeader from './PublicHeader';
import PublicFooter from './PublicFooter';
import ScrollToTop from './ScrollToTop';
import WhatsAppButton from './WhatsAppButton';
import VehicleCard from './VehicleCard';
import SEOHead from './SEOHead';
import { useVehicles } from '@/contexts/VehicleContext';

const FavoritesPage = () => {
  const navigate = useNavigate();
  const { favorites } = useVehicles();

  return (
    <div className="min-h-screen bg-gray-50">
      <SEOHead title="My Favorites - Global Trade Car" />
      <PublicHeader />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Header */}
        <div className="mb-8">
          <Button
            variant="ghost"
            onClick={() => navigate('/vehicles')}
            className="mb-4"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Vehicles
          </Button>
          <div className="flex items-center space-x-3">
            <Heart className="h-8 w-8 text-red-500 fill-current" />
            <h1 className="text-3xl font-bold text-gray-900">My Favorites</h1>
          </div>
          <p className="text-gray-600 mt-2">
            {favorites.length} saved vehicle{favorites.length !== 1 ? 's' : ''}
          </p>
        </div>

        {/* Favorites Grid */}
        {favorites.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {favorites.map((vehicle) => (
              <VehicleCard 
                key={vehicle.id} 
                vehicle={vehicle} 
              />
            ))}
          </div>
        ) : (
          <div className="text-center py-20">
            <Heart className="h-16 w-16 text-gray-300 mx-auto mb-4" />
            <h2 className="text-2xl font-bold text-gray-700 mb-2">No Favorites Yet</h2>
            <p className="text-gray-500 mb-8">
              Save vehicles you're interested in to view them here
            </p>
            <Button 
              onClick={() => navigate('/vehicles')}
              className="bg-red-600 hover:bg-red-700"
            >
              Browse Vehicles
            </Button>
          </div>
        )}
      </div>

      <PublicFooter />
      <ScrollToTop />
      <WhatsAppButton />
    </div>
  );
};

export default FavoritesPage;
